import type { ButtonHTMLAttributes, ReactElement, ReactNode } from "react";
import styles from "./InspectorChipButton.module.css";

export interface InspectorChipButtonGridProps {
  children: ReactNode;
  className?: string;
}

export function InspectorChipButtonGrid({
  children,
  className
}: InspectorChipButtonGridProps): ReactElement {
  return (
    <div className={className ? `${styles.grid} ${className}` : styles.grid}>
      {children}
    </div>
  );
}

export interface InspectorChipButtonRowProps {
  children: ReactNode;
  className?: string;
}

export function InspectorChipButtonRow({
  children,
  className
}: InspectorChipButtonRowProps): ReactElement {
  return (
    <div
      className={className ? `${styles.row} ${className}` : styles.row}
      data-inspector-chip-row
    >
      {children}
    </div>
  );
}

export interface InspectorChipButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  /** Span the full row width (single button in a grid). */
  fullWidth?: boolean;
  /** Handset drawer sizing — matches drawer nav row height. */
  drawerRail?: boolean;
}

export function InspectorChipButton({
  children,
  className,
  fullWidth = false,
  drawerRail = false,
  ...rest
}: InspectorChipButtonProps): ReactElement {
  const classes = [
    styles.btn,
    drawerRail ? styles.btnDrawerRail : "",
    fullWidth ? styles.btnFull : "",
    className ?? ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}
